export default __webpack_public_path__ + "static/media/rosary_image_sm.5fd49701.svg";